export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13134.a9002c35.jpg";